import ArticleCard from './ArticleCard';
export default {
  name: 'news-panel',
  components: {
    ArticleCard
  },
  props: {
    articleList: {
      type: Array,
      required: true
    },
    total: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      pageIndex: 1,
      pageSize: 10
    };
  },
  methods: {
    handlePageChange(pageIndex, pageSize) {
      this.$emit('pageChange', pageIndex, pageSize);
    },
    handleSizeChange(current, size) {
      this.$emit('sizeChange', current, size);
    }
  }
};